// The reviver's third argument, `context.source`, is the raw JSON text for
// the current value; the polyfill supplies it on browsers that lack it.
import "core-js/actual/json/parse";

/**
 * A `JSON.parse` reviver that returns a `bigint` for an integer token under
 * any of `keys`, at any depth, re-read from the raw token text in
 * `context.source` so no digit is lost. A float or exponent literal, a
 * string, a boolean, `null`, and any value under another key come back as
 * the default parse produced them.
 */
export function reviveIntegersAsBigInt(keys: Iterable<string>) {
  const keySet = new Set(keys);
  return (key: string, value: unknown, context?: { source: string }) =>
    keySet.has(key) &&
    typeof value === "number" &&
    context !== undefined &&
    /^-?\d+$/.test(context.source)
      ? BigInt(context.source)
      : value;
}
